<template>
  <div>
    <div class="fn">{{ address.firstName }} {{ address.lastName }}</div>
    <div>
      <div class="adr">
        <div v-if="address.street1 || address.street2">
          <span v-if="address.street1">{{ address.street1 }}</span>
          <span v-if="address.street1">{{ address.street2 }}</span>
        </div>
        <span v-if="address.city">{{ address.city }} </span>
        <span v-if="address.state">{{ stateName }} </span>
        <span v-if="address.postal">{{ address.postal }}</span>
      </div>
      <div class="email" v-if="address.email">{{ address.email }}</div>
      <div class="tel" v-if="address.phone">{{ address.phone }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    address: {
      type: Object,
      required: true,
    },
  },
  computed: {
    stateName() {
      const state = this.$configuration.states.find(state => {
        return this.address.state === state.id;
      });

      return state ? state.description : 'N/A';
    },
  },
};
</script>

<style lang="scss" scoped></style>
